<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save" class="py-6">
    <v-row>

      <v-col cols="12" sm="6">
        <product-category-combobox
            v-model="form.category"
            :input-errors="inputErrors"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="tag"
            name="quantity"
            v-model.number="form.quantity"
            type="number"
            :label="$t('delivery.promo.labels.quantity')"
            :placeholder="$t('delivery.promo.labels.quantity')"
            :error="hasInputErrors('quantity')"
            :error-messages="getInputErrors('quantity')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="12">
        <product-combobox
            v-model="form.products" multiple chips
            :category="form.category"
            :input-errors="inputErrors"
        />
      </v-col>


    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import ProductCategoryCombobox from "@/modules/delivery/combobox/ProductCategoryCombobox/ProductCategoryCombobox.vue";
import ProductCombobox from "@/modules/delivery/combobox/ProductCombobox/ProductCombobox.vue";


export default {
  name: "PromoConfigForm",
  components: {ProductCombobox, ProductCategoryCombobox},
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    save() {
      this.$emit('save', this.form)
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>

